import {signal, WritableSignal} from '@angular/core';

export const isViewInitializedSignal: WritableSignal<boolean> = signal<boolean>(false);
